module.exports = __webpack_public_path__ + "img/building_jicheng.b895a09d.png";